import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../session/session.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardProvider {
  constructor(
    protected auth: AuthService,
    protected session: SessionService,
    protected router: Router) {
  }

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const o = this.auth.isLoggedIn();
    o.toPromise().then((isLoggedIn) => {
      if (!isLoggedIn) {
        this.session.logout();
        
        if (location.pathname.includes('borgenar'))
          this.router.navigate(['/borgenar']);
        else
          this.router.navigate(['/home']);
      }
    });
    return o;
  }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(AuthGuardProvider).canActivate(next, state);
}
